<template>
  <div>
    <div class="user" :class="className" v-if="users.length === 1">
      <div class="circle">{{ users[0].initials }}</div>
      <div class="text">
        <h4 :class="{ noMargin: !text }">{{ users[0].name }}</h4>
        <p>{{ text }}</p>
      </div>
    </div>

    <div class="user users" :class="className" v-if="users.length > 1">
      <div class="circle">{{ users.length }}</div>
      <div class="text" v-tooltip.bottom="{ content: popoverContent, delay }">
        <h4>{{ text }}s</h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'User',
  props: {
    users: Array,
    text: String,
    className: String,
  },
  data() {
    return {
      delay: { show: 700, hide: 0 },
    };
  },
  computed: {
    popoverContent() {
      if (this.users.length < 2) return '';

      let content = `<div class="large"><h6><span>${this.text}s</span></h6>`;

      this.users.forEach(user => {
        content += `<p>${user.name}</p>`;
      });

      content += '</div>';

      return content;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.user {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
  margin: 15px 0 25px;
  width: 100%;

  &:last-child {
    margin-bottom: 7px;
  }

  &.indented {
    width: 100%;
    padding: 7px 15px;
    margin: 3px 0;
  }

  &.selected {
    background: #e4e7ed;
    background-image: url(~@/assets/check.svg);
    background-repeat: no-repeat;
    background-position: center right 15px;
    background-size: 18px 18px;

    h4 {
      max-width: calc(100% - 30px);
    }
  }
}

.circle {
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 20px;
  margin-right: 8px;
  color: white;
  background: #26292f;
  background: #26292f;
  border: 2px solid #26292f;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 13px;
  user-select: none;
}

.users .circle {
  background: white;
  color: #26292f;
}

.text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: calc(100% - 48px);

  h4,
  p {
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    user-select: none;
  }

  h4 {
    font-size: 14px;
    font-weight: 400;
    color: #26292f;
    margin-top: 3px;

    &.noMargin {
      margin-top: 0;
    }
  }

  p {
    font-size: 13px;
    font-weight: 400;
    color: #acb6c1;
  }
}

.users .text {
  h4 {
    margin-top: 0;
    text-decoration: underline;
    color: #acb6c1;
    padding-bottom: 1px;
    user-select: none;
  }

  cursor: pointer;
}
</style>
